import messageUtils from "@utils/messageUtils";
import axios from "axios";

import Jsona from "jsona";

const dataFormatter = new Jsona();

export const state = {
  notification: null,
  shouldFetchNotifications: false,
};

export const actions = {
  async getNotifications({ commit }, payload) {
    try {
      const response = await axios.get(`/v1/notifications${payload}`);
      return {
        data: dataFormatter.deserialize(response.data),
        headers: response.headers,
      };
    } catch (error) {
      messageUtils.showErrors(error);
      return Promise.reject(error);
    }
  },

  async updateNotifications({ commit }, id, payload) {
    try {
      return axios.patch(`/v1/notifications/${id}`, { ...payload });
    } catch (error) {
      messageUtils.showErrors(error);
      return Promise.reject(error);
    }
  },


};

export const mutations = {
  setNotification(state, notification) {
    state.notification = notification;
  },

  setShouldFetchNotifications(state, value) {
    state.shouldFetchNotifications = value;
  },
  
};
